import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom'
import { fetchCourseData, saveCourseWithAnotherLang, saveDuplicateCourse} from '../../../service/course';
import CustomToast from '../../Toast';
import Modal from 'react-modal';
import Select from 'react-select';
import { fetchLanguagesData } from '../../../service/languages';
import Loader from '../../layouts/loader';

const Courses = () => {
    const [course, setcourse] = useState({});
    const [courseList, setCourseList] = useState([])
    const [search, setSearch] = useState('')
    const [isDuplicateModalOpen, setDuplicateModalOpen] = useState(false);
    const [isCreateModalOpen, setCreateModalOpen] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState({});
    const [languages, setLanguages] = useState([]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [courseName, setCourseName] = useState('');
    const [duplicateCourseName, setDuplicateCourseName] = useState('');
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getCourses()
    }, [])

    const getCourses = async () => {
        setLoader(true);
        try {
            const course = await fetchCourseData(search);
            if (course.status) {
                setcourse(course.data);
                setCourseList(course?.data?.results);
                setLoader(false);
               // console.log("=====", courseList)
                
            } else {
                setLoader(false);
                console.error("Error fetching courses:", course.error);
                CustomToast.error('Error while fetching courses')
            }
        } catch (error) {
            setLoader(false);
            console.error("An unexpected error occurred:", error);
            CustomToast.error('Error while fetching courses')
        }
    };

    function handleSearch(e) {
        const value = e.target.value;
    
        if (value) {
            const filteredOptions = courseList?.filter(option =>
                option?.course_name?.toLowerCase().includes(value.toLowerCase())
            );
            setCourseList(filteredOptions);
        } else {
            getCourses();
        }
    }

    const dateFormat = (dateString) => {
        // Convert the date string to a Date object
        const dateObject = new Date(dateString);
        // Format the date as dd-mm-yyyy
        const formattedDate = dateObject.toLocaleDateString('en-GB'); // 'en-GB' for dd-mm-yyyy format
        return formattedDate
    }

    const editCourse = async(courseId,courseName,data)=>{
        await sessionStorage.setItem("courseId",courseId)
        await sessionStorage.setItem("courseName",courseName)
        await sessionStorage.setItem("selectedLanguages",JSON.stringify([{"value":data?.course_meta_id,"label":data?.lang}]))
        navigate('/course_details');
    }

    const openDuplicateModal = (item) => {
        setDuplicateModalOpen(true);
        setSelectedCourse(item);
        //console.log("course", item, selectedCourse)
    };

    const openCreateModal = (item) => {
        setCreateModalOpen(true);
        setSelectedCourse(item);
        getLanguages();
    };

    const closeModal = () => {
        setDuplicateModalOpen(false);
        setCreateModalOpen(false);
        setSelectedLanguages([]);
        setDuplicateCourseName('');
    };

    const getLanguages = async () => {
        try {
          const languagesData = await fetchLanguagesData();       
          if (languagesData.status) {
            setLanguages(languagesData.data);
          } else {
            console.error("Error fetching languages:", languagesData.error);
          }
        } catch (error) {
          console.error("An unexpected error occurred:", error);
        }
      };
    
      const handleLanguageChange = (selectedOptions) => {
        setSelectedLanguages(selectedOptions);
        sessionStorage.setItem("selectedLanguages",JSON.stringify(selectedOptions))
      };
    
      const handleCourseNameChange = (duplicateCourseName) => {
        setDuplicateCourseName(duplicateCourseName.target.value);
        sessionStorage.setItem("new courseName", duplicateCourseName.target.value)
      };

      const usedLangs = selectedCourse?.courses?.map(course => course.lang);

      const availableLanguages = languages.filter(
        lang => !usedLangs?.includes(lang.name)
      );

      const languageOptions = availableLanguages.map((lang) => ({
        value: lang._id,
        label: lang.name,
      }));
        
    const createCourses =  async (selectedCourse) => {
    const selectedLanguages = JSON.parse(sessionStorage.getItem("selectedLanguages"));
    let data = {
        courseId: selectedCourse?.course_id,
        language: selectedLanguages.label,
        langId: selectedLanguages.value,
        rankNo: selectedLanguages.label === 'English' ? 1 : selectedLanguages.label === 'Hindi' ? 2 : selectedLanguages.label === 'Marathi' ? 3 : null,
    } 
    await saveCourseWithAnotherLang(data);
    closeModal();
    getCourses();
    }

  const duplicateCourse = async (selectedCourse) => {
    let data = {
        course_id: selectedCourse?.course_id,
        course_name: duplicateCourseName,
    } 
    await saveDuplicateCourse(data);
    closeModal();
    getCourses();
  };

    return (
        <div className='page__main'>
            <div className="dashboard">
                <h4 className="mb-2">Course Builder</h4>
                <div className='row mb-4'>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{course.total_courses || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Courses Created</div>
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{course.published_courses || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Courses Published</div>
                            </p>

                        </div>
                    </div>
                    <div className='col-md-4 text-end'>
                        <a href="/create_course" className='btn btn-primary w-75'>Create Course</a>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center">
                            <div className='row g-3'>
                                <div className="col-auto">
                                    <label for="inputPassword6" className="col-form-label"><b>Courses</b></label>
                                </div>
                                <div className="col-auto">
                                    <div className="form-group has-search">
                                        <span className="form-control-feedback"><img src="/images/search.png" /></span>
                                        <input type="text" onChange={handleSearch} className="form-control" placeholder="Search Course" />
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status green'></span> Published</p>
                                {/* <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status pink'></span> Unpublished</p> */}
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status yellow'></span> Draft</p>
                            </div>
                        </div>

                    </div>
                </div>
                <table className="table border-table">
                    <thead className='thead-dark px-3'>
                        <tr>
                             <th className='w-16 p-3'>Sr.No</th>
                            <th className='w-25 p-3'>Course Name</th>
                            <th className='w-25 p-3'>Created By</th>
                            <th className='w-25 p-3'>Published on</th>
                            <th className='w-25 p-3'>Last Update On</th>
                            <th className='w-50 p-3 text-center'>Languages</th>
                            <th className='w-25 p-3 text-center'>Action</th>
                        </tr>
                    </thead>
                    <tbody>

                        {loader ? <Loader /> : <>
                            {course && courseList?.map((item, index) => (
                                <tr key={index} >
                                    <td className='col px-3 text-center'>{index + 1}</td>
                                    <td className='col px-3'>{item?.course_name || '-'}</td>
                                    <td className='col px-3'>{item?.created_by || '-'}</td>
                                    <td className='col px-3'>{item?.published_date != null ? dateFormat(item?.published_date) || '-' : '-'}</td>
                                    <td className='col px-3'>{dateFormat(item?.updatedAt) || '-'}</td>
                                    <td className='col px-3 text-center'>
                                        {item && item.courses?.map((data) => (
                                            <a style={{ cursor: "pointer" }} onClick={() => editCourse(data?.course_meta_id, item?.course_name, data)} className={`status-btn ${data.lang === "unpublished" ? 'btn-pink' : data.status === "draft" ? 'btn-yellow' : 'btn-green'}`}>{data?.lang || '-'}</a>
                                        ))}
                                    </td>
                                    <td align='right' >
                                        <div className='d-flex flex-column'>

                                            <div key={item.course_id} className="dropdown organisations" style={{ cursor: "pointer" }}>
                                                <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"
                                                    width="30px" height="30px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" >
                                                    <path d="M20,44c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,47.3,20,44z M20,26c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6
	S20,29.3,20,26z M20,8c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,11.3,20,8z"/>
                                                </svg>
                                                <div className="dropdown-menu">
                                                    <a style={{ cursor: "pointer" }} onClick={() => openDuplicateModal(item)} className={`dropdown-item me-2`}>Duplicate Course</a>
                                                    <a style={{ cursor: "pointer" }} onClick={() => openCreateModal(item)} className={`dropdown-item`}>Add Language</a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>))} </>}

                        {selectedCourse &&
                            <Modal
                                isOpen={isDuplicateModalOpen}
                                onRequestClose={closeModal}
                                contentLabel="Duplicate Modal"
                                className='Modal bg-white text-end p-3'
                            > <svg onClick={closeModal} style={{ cursor: "pointer" }} width="35" height="35" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                    <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                                </svg>
                                <div className='d-flex flex-column justify-content-center align-items-center w-100 mb-4 px-4'>
                                    <h3 className='fw-bold font-20 mb-5'>Duplicate Course</h3>
                                    <form className='w-100'>
                                        <div className="form-group mb-4 text-start">
                                            <label htmlFor="name">Current Course Name :</label>
                                            <input type="text" className="form-control fw-bold w-100 mt-2" id="name" value={selectedCourse.course_name} disabled />
                                        </div>
                                        <div className="form-group mb-4 pb-3 text-start">
                                            <label htmlFor="name">Enter New Course Name :</label>
                                            <input type="text" className="form-control w-100 mt-2" id="name" value={duplicateCourseName} onChange={handleCourseNameChange} />
                                        </div>
                                    </form>
                                    <button type='button' style={{ cursor: "pointer" }} onClick={() => duplicateCourse(selectedCourse)} className={`btn btn-primary w-100 px-5`}>Duplicate</button>
                                </div>
                            </Modal>}

                        {selectedCourse &&
                            <Modal
                                isOpen={isCreateModalOpen}
                                onRequestClose={closeModal}
                                contentLabel="Duplicate Modal"
                                className='Modal bg-white text-end p-3'
                            >  <svg onClick={closeModal} style={{ cursor: "pointer" }} width="35" height="35" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                    <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                                </svg>

                                <div className='d-flex flex-column justify-content-center align-items-center w-100 mb-4 px-4'>
                                <h3 className='fw-bold font-20 mb-4'>Add Language</h3>
                                    <form className='w-100'>
                                    <div className="form-group mb-4 text-start">
                                            <label htmlFor="name">Add Language for Course :</label>
                                            <input type="text" className="form-control fw-bold w-100 mt-2" id="name" value={selectedCourse.course_name} disabled />
                                        </div>
                                        <div className="form-group mb-4 pb-3 mx-auto text-start">
                                            <label className='mb-2'>Select Language :</label>
                                            <Select
                                               // isMulti
                                                options={languageOptions}
                                                value={selectedLanguages}
                                                onChange={handleLanguageChange}
                                            />
                                        </div>
                                    </form>
                                    <button type='button' style={{ cursor: "pointer" }} onClick={() => createCourses(selectedCourse)} className={`btn btn-primary w-100 px-5`}>Add</button>
                                </div>
                            </Modal>}
                    </tbody>
                </table>
                {course&&course.results?.length==0?(<h3 style={{paddingLeft:"40%", paddingTop:"10%"}}>No Data Found</h3>):null}
            </div>
        </div>
    )
}

export default Courses;